export function formatMetric(
  value: number | null | undefined,
  digits = 2
): string {
  if (value == null || !Number.isFinite(Number(value))) return '—';
  const n = Number(value);
  if (digits <= 0) return String(Math.round(n));
  return parseFloat(n.toFixed(digits)).toString();
}

/** Проценты ТО/налёта: всегда две цифры после точки (36.00, не 36). */
export function formatPercent(value: number | null | undefined): string {
  const n = Number(value);
  if (!Number.isFinite(n)) return '0.00';
  return n.toFixed(2);
}
